export const setItem = (key: string, value: string) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getItem = (key: string) => {
  const value = localStorage.getItem(key);
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return value; // Si no es JSON, devolver tal cual
  }
};

export const removeItem = (key: string) => {
  localStorage.removeItem(key);
};
